import { makeStyles, Switch as MuiSwitch, SwitchProps, Theme } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles<Theme, { size?: 'small' | 'medium' }>((theme) => ({
  root: {
    width: ({ size }) => (size === 'medium' ? 60 : 40),
    height: ({ size }) => (size === 'medium' ? 32 : 24),
    padding: 0,
    margin: theme.spacing(1),
    opacity: 1,
  },
  switchBase: {
    padding: ({ size }) => (size === 'medium' ? 4 : 3.5),
    color: theme.palette.common.white,
    border: 'none',
    '&$checked': {
      color: theme.palette.common.white,
      transform: 'translateX(29px)',
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 32 / 2,
    backgroundColor: '#828282',
    opacity: 1,
    transition: 'all 100ms ease-in-out',
  },
  checked: {},
}));

export const Switch: React.FC<SwitchProps> = (props) => {
  const switchStyles = useStyles({ size: props.size });
  return <MuiSwitch {...props} classes={switchStyles} />;
};
